"use strict";

angular.module('rmSidebar')
    .config(['$stateProvider', function ($stateProvider) {

        $stateProvider
            .state('widget', {
                url: '/widgets/:widgetId',
                onEnter: ['bladesManager', 'widgets', '$stateParams', 'elementReady', function (bladesManager, widgets, $stateParams, elementReady) {
                    let widgetId = $stateParams.widgetId;
                    bladesManager.clearAll();
                    bladesManager.insert({viewName: 'widget-' + widgetId, size: 'full'});

                    elementReady("ui-view[name='widget-" + widgetId + "']").then((container) => {
                        widgets.getWidgetById(widgetId, 'menu').then((widget) => {
                            let uniqueWidgetId = 'menu_' + widget.id;
                            widgets.unRegisterWidget(uniqueWidgetId);
                            widgets.createWidgetFrame(
                                uniqueWidgetId,
                                widget,
                                undefined,
                                'menu',
                                event => void event,
                                () => ([]),
                                {}, // @todo add extra data fields
                            )
                                .then(newEl => {
                                    newEl.className = 'widget-full';
                                    container.append(newEl);
                                });
                        });
                    });
                }],
                onExit: ['bladesManager', function (bladesManager) {
                    bladesManager.clearAll();
                }]
            })
        ;
    }]);